export default __webpack_public_path__ + "static/media/1751.884dee7a.png";